import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useLogoutAndRedirect from '@/hooks/useLogoutAndRedirect';
import selectors from '@/redux/selectors/selectors';
import setErrorSplashScreen from '@/lib/setErrorSplashScreen';
import Button from './Button.jsx';

const ErrorSplash = () => {
  const logoutAndRedirect = useLogoutAndRedirect();
  const { message = 'Please contact MindCloud support.', actions = [] } = useSelector(selectors.errorSplashScreen);

  const supportedActions = useMemo(
    () => ({
      CLOSE: {
        label: 'Close',
        action: () => setErrorSplashScreen(false)
      },
      SIGN_OUT: {
        label: 'Sign Out',
        action: () => logoutAndRedirect()
      },
      RELOAD: {
        label: 'Reload',
        action: () => window.location.reload()
      }
    }),
    []
  );

  return (
    <div className="comp-no-company-splash-screen">
      <div className="container">
        <h1 className="title">Something went wrong!</h1>
        <p className="subtext">{message}</p>
        <div className={'buttons'}>
          {actions.map((n) => {
            const action = supportedActions[n];

            if (!action) {
              return null;
            }

            return (
              <Button key={n} size="sm" onClick={action.action}>
                {action.label}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ErrorSplash;
